<template>
  <div>
    <div class="grid-content">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>管理员模块</el-breadcrumb-item>
        <el-breadcrumb-item>新增企业</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row :gutter="0"
            class="grid-content">
      <el-col :span="12">
        <div class="inputDiv">
          <div class="inputLeft">公司名称：</div>
          <el-input v-model="enterprise.name"
                    style="width: unset;"
                    placeholder="请输入公司名称"></el-input>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">负责人名称：</span>
          <el-input v-model="enterprise.contacts"
                    class="inputRight"
                    style="width: unset;"
                    placeholder="请输入负责人名称"></el-input>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">登陆账号：</span>
          <el-input v-model="enterprise.userName"
                    class="inputRight"
                    style="width: unset;"
                    placeholder="请输入登陆账号"></el-input>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">工资隐藏：</span>
          <el-select v-model="enterprise.priceHide"
                     placeholder>
            <el-option v-for="item in priceHideList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">有效期：</div>
          <el-select v-model="value"
                     style="width:200px"
                     placeholder="请选择"
                     @change="getExpirationDate">
            <el-option v-for="item in options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">上午上班时间：</span>
          <el-time-select class="inputRight"
                          style="width: unset;"
                          v-model="workingTime.toWork1"
                          :picker-options="{
              start: '04:00',
              step: '00:05',
              end: '23:30'
            }"
                          placeholder="选择时间"></el-time-select>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">下午上班时间：</span>
          <el-time-select class="inputRight"
                          style="width: unset;"
                          v-model="workingTime.toWork2"
                          :picker-options="{
              start: '04:00',
              step: '00:05',
              end: '23:30'
            }"
                          placeholder="选择时间"></el-time-select>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">地址：</div>
          <el-input v-model="address.province"
                    class="inputdi"
                    style="width: unset;"
                    :disabled="true"
                    placeholder="省"></el-input>
          <el-input v-model="address.city"
                    class="inputdi"
                    style="width: unset;"
                    :disabled="true"
                    placeholder="市"></el-input>
          <el-input v-model="address.county"
                    class="inputdi"
                    style="width: unset;"
                    :disabled="true"
                    placeholder="区"></el-input>
        </div>
      </el-col>

      <el-col :span="12">
        <div class="inputDiv">
          <div class="inputLeft">公司人数：</div>
          <el-input v-model="enterprise.employeesLimit"
                    style="width: unset;"
                    placeholder="请输入公司人数"></el-input>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">负责人电话：</div>
          <el-input v-model="enterprise.tel"
                    style="width: unset;"
                    placeholder="请输入负责人电话"></el-input>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">登陆密码：</div>
          <el-input v-model="enterprise.pass"
                    class="inputRight"
                    style="width: unset;"
                    placeholder="请输入登陆密码"></el-input>
        </div>
        <div class="inputDiv"
             style="height: 31px;"></div>
        <div class="inputDiv"
             style="height: 31px;">
          <div>{{ btime }}--至--{{ etime }}</div>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">上午下班时间：</span>
          <el-time-select class="inputRight"
                          style="width: unset;"
                          v-model="workingTime.offWork1"
                          :picker-options="{
                            start: '04:00',
                            step: '00:05',
                            end: '23:30'
                          }"
                          placeholder="选择时间"></el-time-select>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">下午下班时间：</span>
          <el-time-select class="inputRight"
                          style="width: unset;"
                          v-model="workingTime.offWork2"
                          :picker-options="{
              start: '04:00',
              step: '00:05',
              end: '23:30'
            }"
                          placeholder="选择时间"></el-time-select>
        </div>
        <div class="inputDiv">
          <el-input type="textarea"
                    :rows="1"
                    placeholder="请输入详细地址"
                    v-model="address.address"></el-input>
        </div>
      </el-col>
    </el-row>

    <baidu-map class="map"
               style="height: 400px"
               center="宝鸡"
               :scroll-wheel-zoom="true"
               @ready="mapReady"
               @click="getPoint"
               :zoom="15">
      <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
      <bm-marker :position="point"
                 animation="BMAP_ANIMATION_BOUNCE"></bm-marker>
    </baidu-map>

    <div class="inputDiv">
      <el-button type="primary"
                 class="widthButton"
                 @click="add">确认</el-button>
      <el-button class="widthButton"
                 @click="goback">取消</el-button>
    </div>
  </div>
</template>

<script>
import { enterpriseAdd } from "@/api/enterprise";
import { bd09togcj02, gcj02towgs84 } from "@/util/coordtransform";
import moment from "moment";
export default {
  data () {
    return {
      enterprise: {
        name: "",
        contacts: "",
        employeesLimit: "",
        industry: 1,
        userName: "",
        tel: "",
        pass: "",
        priceHide: 1
      },
      geoCoder: {},
      address: {},
      point: {},
      value: 1,
      btime: "",
      etime: "",
      workingTime: {},
      priceHideList: [
        {
          value: 0,
          label: "不隐藏"
        },
        {
          value: 1,
          label: "隐藏"
        }
      ],
      options: [
        {
          value: 1,
          label: "一个月"
        },
        {
          value: 2,
          label: "两个月"
        },
        {
          value: 3,
          label: "三个月"
        },
        {
          value: 4,
          label: "四个月"
        },
        {
          value: 5,
          label: "五个月"
        },
        {
          value: 6,
          label: "半年"
        },
        {
          value: 12,
          label: "一年"
        },
        {
          value: 24,
          label: "两年"
        },
        {
          value: 36,
          label: "三年"
        }
      ]
    };
  },
  mounted () {
    this.btime = moment(new Date()).format("YYYY-MM-DD");
    this.getExpirationDate(this.value);
  },
  methods: {
    goback () {
      this.$router.go(-1);
    },
    add () {
      if (
        !this.workingTime.toWork1 &&
        !this.workingTime.offWork1 &&
        !this.workingTime.toWork2 &&
        !this.workingTime.offWork2
      ) {
        this.$message({
          type: "error",
          message: "请输入上下班时间！"
        });
        return;
      }
      const gcj02 = bd09togcj02(this.point.lng, this.point.lat);
      const wgs84 = gcj02towgs84(gcj02[0], gcj02[1]);
      const params = {
        ...this.enterprise,
        ...this.address,
        employees: this.enterprise.employeesLimit,
        lon: wgs84[0],
        lat: wgs84[1],
        workingTime:
          this.workingTime.toWork1 +
          "-" +
          this.workingTime.offWork1 +
          ";" +
          this.workingTime.toWork2 +
          "-" +
          this.workingTime.offWork2,
        validity: this.etime,
        remark: "",
        states: 1
      };
      enterpriseAdd(params)
        .then(() => {
          this.$message({
            type: "success",
            message: "新增成功!"
          });
          this.goback();
        })
        .catch(err => {
          console.log(err);
        });
    },
    getPoint (e) {
      this.point = e.point;
      this.geoCoder.getLocation(e.point, rs => {
        const addComp = rs.addressComponents;
        this.address = {
          province: addComp.province,
          city: addComp.city,
          county: addComp.district,
          address: addComp.street + addComp.streetNumber
        };
        if (rs.surroundingPois.length > 0 && rs.surroundingPois[0].title) {
          this.address.address += " : " + rs.surroundingPois[0].title;
        }
      });
    },
    mapReady (e) {
      const BMap = e.BMap;
      this.geoCoder = new BMap.Geocoder();
    },
    getExpirationDate (value) {
      const s = this.btime.split("-");
      const yy = parseInt(s[0]);
      const mm = parseInt(s[1]) - 1;
      const dd = parseInt(s[2]);
      const dt = new Date(yy, mm, dd);
      dt.setMonth(dt.getMonth() + value);
      this.etime = moment(dt).format("YYYY-MM-DD");
    }
  }
};
</script>

<style></style>
